module.exports = __webpack_public_path__ + "img/整蛊聊天气泡.09f2ca1d.png";